module.exports = __webpack_public_path__ + "img/logo_psj.829dcaf1.jpg";